import { render } from "./FridgeDoorMonitorDaily.vue?vue&type=template&id=b3d0aa2c&scoped=true&ts=true"
import script from "./FridgeDoorMonitorDaily.vue?vue&type=script&lang=ts"
export * from "./FridgeDoorMonitorDaily.vue?vue&type=script&lang=ts"

import "./FridgeDoorMonitorDaily.vue?vue&type=style&index=0&id=b3d0aa2c&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d0aa2c"]])

export default __exports__